<template>
  <div class="articles">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="filters">

          <div class="filter form_select">
            <fg-input
                v-model="filter.q"
                type="text"
                :placeholder="translate('device_models.search')"
                :label="translate('device_models.search')"
                :clearable="true"
            />
          </div>

          <div class="filter form_select">
            <label> {{ translate("device_models.models") }} </label>
            <tree-select
                :options="device_models_list"
                :multiple="false"
                v-model="filter.device_plate"
                :placeholder="translate('device_models.models')"
                :clearable="true"
            />
          </div>

          <div class="filter form_select">
            <label> {{ translate("device_models.radio_module_count") }} </label>
            <tree-select
                :options="device_radio_module_count"
                :multiple="false"
                v-model="filter.radio_module_count"
                :placeholder="translate('device_models.radio_module_count')"
                :clearable="true"
            />
          </div>

          <div class="filter form_select">
            <label> {{ translate("device_models.params") }} </label>
            <tree-select
                :options="params_list"
                :multiple="true"
                v-model="params"
                :placeholder="translate('device_models.params')"
                :clearable="true"
            />
          </div>


          <div class="filter"></div>
          <div class="filter"></div>
        </div>

      </div>
    </div>

    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th
              class="pointer"
              @click="change_filter('sku')"
              :class="{ selected: filter_type === 'sku' }"
              scope="col"
          >
            {{ translate('device_models.sku') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('device_model_name')"
              :class="{ selected: filter_type === 'device_model_name' }"
              scope="col"
          >
            {{ translate('device_models.device_model_name') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('radio_module_count')"
              :class="{ selected: filter_type === 'radio_module_count' }"
              scope="col"
          >
            {{ translate('device_models.radio_module_count') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('has_wifi')"
              :class="{ selected: filter_type === 'has_wifi' }"
              scope="col"
          >
            {{ translate('device_models.has_wifi') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('has_poe_in')"
              :class="{ selected: filter_type === 'has_poe_in' }"
              scope="col"
          >
            {{ translate('device_models.has_poe_in') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('has_poe_out')"
              :class="{ selected: filter_type === 'has_poe_out' }"
              scope="col"
          >
            {{ translate('device_models.has_poe_out') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('ip_protection_class')"
              :class="{ selected: filter_type === 'ip_protection_class' }"
              scope="col"
          >
            {{ translate('device_models.ip_protection_class') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th class="w50">

          </th>
        </tr>
        </thead>
        <tbody>
          <tr
              v-for="(data, key) in device_skus"
              :key="key"
              class="sku_item pointer"
              @click="show_text_config(data, key)"
          >
            <td :data-label="translate('device_models.sku')" :title="data.id" class="text-left" @click.stop.prevent="">
              <router-link :to="'/device_list?&device_sku_id=' + data.id" class="link">
                {{ data.sku }}
              </router-link>
              <span class="mdi mdi-content-copy pointer" @click="copy(data.sku)" />
            </td>
            <td :data-label="translate('device_models.device_model_name')" class="text-left">
              {{ data.device_model_name }}
            </td>
            <td :data-label="translate('device_models.radio_module_count')">
              {{ data.radio_module_count }}
            </td>
            <td :data-label="translate('device_models.has_wifi')">
              {{ data.has_wifi > 0 ? "+" : "-" }}
            </td>
            <td :data-label="translate('device_models.has_poe_in')">
              {{ data.has_poe_in > 0 ? "+" : "-" }}
            </td>
            <td :data-label="translate('device_models.has_poe_out')">
              {{ data.has_poe_out > 0 ? "+" : "-"}}
            </td>
            <td :data-label="translate('device_models.ip_protection_class')">
              {{ data.ip_protection_class }}
            </td>
            <td class="w50">
              <span
                v-if="data.test_config"
                class="mdi mdi-cog pointer"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import EditTestConfig from "./Modal/EditTestConfig.vue";

export default {
  name: 'Articles',
  data () {
    return {
      all_data: [],
      filter_asc: "asc",
      filter_type: "",
      filter:{
        device_plate: null,
        radio_module_count: null,
        has_wifi: null,
        has_poe_in: null,
        has_poe_out: null,
        ip_protection_class: null,
        q: ""
      },
      params: [],

      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    sended_filter(){
      const filter = {}
      Object.keys(this.filter).forEach(key =>{
        if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== ''){
          filter[key] = this.filter[key]
        }
      })
      return filter
    },
    device_skus(){
      let device_skus = [...this.all_data];
      return device_skus.sort(this.compareNumbers);
    },

    device_models_list() {
      return this.$store.getters.getDeviceModels.map((model) => {
        return {id: model.name, label: model.name}
      })
    },

    device_radio_module_count() {
      return [1,2,3,4,5,6,7,8].map((num) => {
        return {id: num, label: num}
      })
    },

    params_list() {
      return [
        {id: "has_wifi", label: this.translate("device_models.has_wifi")},
        {id: "has_poe_in", label: this.translate("device_models.has_poe_in")},
        {id: "has_poe_out", label: this.translate("device_models.has_poe_out")},
        {id: "ip_protection_class_44", label: `${this.translate("device_models.ip_protection_class")} 44`},
        {id: "ip_protection_class_65", label: `${this.translate("device_models.ip_protection_class")} 65`},
      ]
    },
  },

  watch:{
    params:{
      deep: true,
      handler(){
        this.params_list.forEach((param) =>{
          if (param.id !== "ip_protection_class_44" && param.id !== "ip_protection_class_65"){
            if (this.params.indexOf(param.id) > -1){
              this.filter[param.id] = 1
            } else {
              this.filter[param.id] = null
            }
          } else {
            if (this.params.indexOf("ip_protection_class_44") > -1){
              this.filter.ip_protection_class = 44
            } else if(this.params.indexOf("ip_protection_class_65") > -1){
              this.filter.ip_protection_class = 65
            } else {
              this.filter.ip_protection_class = null
            }
          }
        })
      }
    },
    filter:{
      deep: true,
      handler(){
        this.change_input()
      }
    }
  },

  created () {
    this.get_model_list()
  },

  methods:{
    show_text_config(data, key) {
      let t = this.$createElement(EditTestConfig, {
        props: {
          id: data.id,
          device_sku: data.sku,
          test_config: data.test_config
        },
        on: {
          update: (new_data) => {
            this.$set(this.all_data, key, { ...new_data });
            this.$modal.hide('show_text_config_modal')
          },
          close: () => {
            this.$modal.hide('show_text_config_modal')
          },
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'show_text_config_modal'
      })
    },
    copy(string){
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_model_list, 500)
    },
    get_model_list(){
      this.$http.v1.getDeviceSku(this.sended_filter, (response) => {
        this.all_data = response.data
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>
  .articles{
    height: 100%;
    padding: 10px 0 0;

    .header{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      flex: 1;
      .filters{
        display: flex;
        justify-content: flex-start;
        width: 100%;
        .filter{
          flex: 1;
          margin-right: 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .form_search{
        .search_user{
          width: 100%;
          margin-bottom: 0;
        }
      }
      .form_select{
        .vue-treeselect{
          margin: 0;
        }
      }
    }

    .response_table{
      height: calc(100% - 100px);
      padding: 10px 0 0;

      .sku_item{
        &:hover{
          background-color: #eeeeee;
        }
      }

      tr{
        font-size: 12px;
        .mdi{
          font-size: 16px;
          line-height: 16px;
        }
      }

      td{
        &.text-left{
          text-align: left;
          padding: 0 7px;
        }
        .mdi{
          font-size: 14px;
          margin-left: 5px;

        }
      }
    }


  }
  @media (max-width: 1300px){
    .response_table{
      font-size: 12px;
    }
  }
</style>
